import { Checkbox, Text } from "@fluentui/react-northstar";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface ViewsSettingProps {
  horizontalScroll: boolean;
  onChange: (horizontalScroll: string) => void;
  cellEditing: boolean;
  onCellEditingChange: (cellEditing: string) => void;
}

export const ViewsSetting: React.FC<ViewsSettingProps> = (
  props: ViewsSettingProps
) => {
  const { t } = useTranslation();
  const [viewPreference, setViewPreference] = useState({
    horizontalScroll: props.horizontalScroll,
    cellEditing: props.cellEditing,
  });

  const onHorizontalScrollCheckChange = (_e, p) => {
    setViewPreference(current => ({ ...current, horizontalScroll: p.checked }));
    props.onChange(p.checked);
  };

  const onCellEditingCheckChange = (_e, p) => {
    setViewPreference(current => ({ ...current, cellEditing: p.checked }));
    props.onCellEditingChange(String(p.checked));
  };

  return (
    <div className="pt-5">
      <Text content={"Views"} size="larger" />
      <div className="pt-5">
        <Checkbox label={t("preferences.enable-horizontal")} onChange={onHorizontalScrollCheckChange} checked={viewPreference.horizontalScroll} toggle />
      </div>
      <div className="pt-3">
        <Checkbox label={t("preferences.enable-cell-editing")} onChange={onCellEditingCheckChange} checked={viewPreference.cellEditing} toggle />
      </div>
    </div>
  );
};
